module.exports = "<aside class=\"side-nav-box\">\n\t<nav class=\"side-nav\" ng-class=\"{'side-nav--stickytop': vm.sticky}\">\n\t\t<a ui-sref-active=\"side-nav__item--current\" ui-sref=\"site.{{item}}\" ng-repeat=\"item in vm.navItems\" class=\"side-nav__item\"\n\t\t ng-bind=\"::'nav.' + item | translate\"></a>\n\t</nav>\n</aside>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/nav/nav.html
// module id = 852
// module chunks = 0